import { useContext } from 'react';
import { AppDataContext } from '@/contexts/app.context';

export function useAppDataContext() {
  return useContext(AppDataContext);
}
